import styled from 'styled-components';

import { colors } from 'theme';

export const SlideshowItem = styled.button<{ $clickable: boolean }>`
  outline: none;
  width: 100%;
  height: 100%;
  background: ${colors.fog};
  display: flex;
  justify-content: center;

  ${(props) =>
    !props.$clickable &&
    `
      pointer-events: none;
      cursor: default;
    `}
`;
